import Store from 'redux/Store'
import { setMessage } from 'redux/actions'

interface prepareSubmitFormProps {
  submitForm: Function
  data: any
  navigate: Function
  setShowOverlay: Function
  name: string
  setError?: Function
}

const prepareSubmitForm = async (props: prepareSubmitFormProps) => {
  props
    .submitForm({
      data: props.data,
      setError: props?.setError,
      setShowOverlay: props.setShowOverlay,
    })
    .then((response: any) => {
      if (response?.status === 200 || response?.status === 201) {
        Store.dispatch(setMessage(props.name + ' successfully saved.', 'success', 'instant'))
        props.setShowOverlay(false)
      }
    })

  return true
}

export default prepareSubmitForm
